import { Controller } from '@hotwired/stimulus';
import { firePendingAction, PENDING_ACTION } from '../utils/pending_action';
import { showToast } from '../lib/boostrap/toast';

export default class ToastController extends Controller {
  connect() {
    firePendingAction(PENDING_ACTION.SHOW_TOAST, ({ type, message }) => {
      showToast(type, message);
      return true;
    });
  }
}
